import {Component, inject, Input, ViewChild} from '@angular/core';
import {UserMetricInstance, WM2EStatus} from "../../../../models/user/Metric/UserMetricInstance";
import {DataTypeGroupEnum} from "../../../../enums/dashboard/DataTypeUnitEnum";
import {ExecWM2ECB} from "../../../../ope/metric/ExecWM2ECB";
import {MetricOpeService} from "../../../../services/ope/metricOpe.service";
import {BaseComponent} from "../../../BaseComponent";
import {
  WriteMetricNotificationService
} from "../../../../services/notification/interfaces/WriteMetricNotificationService";
import {NotificationService} from "../../../../services/notification/notification.service";
import {WriteMetricValueNtf} from "../../../../events/notification/WriteMetricValueNtf";
import {WriteOnEdgeStatusEnum} from "../../../../enums/dashboard/WriteOnEdgeStatusEnum";
import {ValueChangedEvent} from "devextreme/ui/number_box";
import {WriteOnEdgeOriginTypeEnum} from "../../../../enums/registry/WriteOnEdgeOriginTypeEnum";
import {DxValidationGroupComponent} from "devextreme-angular";

@Component({
  selector: 'app-measure-card-form',
  templateUrl: './measure-card-form.component.html',
  styleUrls: ['./measure-card-form.component.css']
})
export class MeasureCardFormComponent extends BaseComponent {

  @ViewChild('validationGroup', { static: false }) validationGroup?: DxValidationGroupComponent;

  @Input() card!: UserMetricInstance;

  newValue?: any;
  editMode: boolean = false;

  protected readonly metricOpeService: MetricOpeService = inject(MetricOpeService);
  protected readonly writeMetricNotificationService: WriteMetricNotificationService = inject(NotificationService);
  protected readonly WriteOnEdgeStatusEnum = WriteOnEdgeStatusEnum;
  protected readonly DataTypeGroupEnum = DataTypeGroupEnum;

  ngOnInit() {
    super.ngOnInit();
    this.subscriptions = [
      this.writeMetricNotificationService.onUpdateWriteMetricValue((event: WriteMetricValueNtf) => {
        const eventValue = event.value;
        this.card.wm2eStatus ??= new WM2EStatus();
        if (eventValue.metricId === this.card.id) {
          this.card.wm2eStatus.valueToWrite = eventValue.valueToWrite;
          this.card.wm2eStatus.commandStatus = eventValue.commandStatus;
          this.card.wm2eStatus.koMessage = eventValue.koMessage;
        }
      })
    ];
    this.writeMetricNotificationService.addWriteMetricIdsToNotifications([this.card.id]);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  startEditMode() {
    this.newValue = this.card.lastValue;
    if (this.card.dataTypeGroup === "REAL" && this.card.lastValue !== null)
      this.newValue = Number(this.card.lastValue.toFixed(this.card.decimalDigits?? 0));
    else if (this.card.dataTypeGroup === DataTypeGroupEnum.INTEGER && this.card.dataTypeGroupShowAsHex && this.card.lastValue !== null)
      this.newValue = '0x' + this.card.lastValue.toString(16).toUpperCase();
    else if (this.card.dataTypeGroup === DataTypeGroupEnum.STRING && this.card.lastValue !== null)
      this.newValue = this.card.lastValue.toString().replace(/\s/g, '');
    this.editMode = true;
  }

  undoWriteNewMetricValue() {
    this.editMode = false;
  }

  writeNewMetricValue() {
    if (this.newValue !== undefined) {
      let cb = new ExecWM2ECB();
      cb.i.metricInstanceId = this.card.id;

      // Convert hex string to decimal if showAsHex is true
      if (this.card.dataTypeGroup === DataTypeGroupEnum.INTEGER && this.card.dataTypeGroupShowAsHex && typeof this.newValue === 'string') {
        // Remove '0x' prefix if present
        const hexValue = this.newValue.startsWith('0x') ? this.newValue.substring(2) : this.newValue;

        // Convert hex string to decimal
        cb.i.valueToWrite = parseInt(hexValue, 16);
      } else if (this.card.dataTypeGroup === DataTypeGroupEnum.STRING) {
        cb.i.valueToWrite = this.newValue.toString();
      } else {
        cb.i.valueToWrite = this.newValue;
      }


      this.metricOpeService.execWM2E(cb)
        .then(() => this.editMode = false)
        .catch(e => this.toastService.openErrorToastMessage(e));
    }
  }

  // Helper method to validate hex value
  isValidHexValue(value: string): boolean {
    // Check if the value is a valid hex number
    return /^[0-9A-Fa-f]+$/.test(value);
  }

  getNumberBoxStep(decimalDigits: number | null | undefined) {
    return decimalDigits && decimalDigits > 0 ? Math.pow(10, -decimalDigits) : 1;
  }

  protected readonly Math = Math;

  roundAndAssignValue($event: ValueChangedEvent) {
    this.newValue = Math.floor($event.value);
    $event.component.reset(this.newValue)
  }

  protected readonly WriteOnEdgeOriginTypeEnum = WriteOnEdgeOriginTypeEnum;

  protected getValueToWriteParsed() {
    if (!this.card.wm2eStatus?.valueToWrite) {
      return this.card.wm2eStatus?.valueToWrite;
    }

    if (this.card.dataTypeGroup === DataTypeGroupEnum.INTEGER && this.card.dataTypeGroupShowAsHex) {
      return '0x' + Number(this.card.wm2eStatus.valueToWrite).toString(16).toUpperCase();
    }

    return this.card.wm2eStatus.valueToWrite;
  }

  isFormValid(): boolean {
    if (!!this.validationGroup) {
      return !!this.validationGroup.instance.validate().isValid
    }
    return false;
  }
}
